import Vue from 'vue'
import VueTagsInput from '@johmun/vue-tags-input';

Vue.use(VueTagsInput);
